import { deleteInstrumento } from './delete-instrumento'
import { getInstrumentos } from './get-instrumentos'
import { get } from './get-operacion-wrm'
import { postInstrumento } from './post-instrumento'
import { post } from './post-operacion-wrm'
import { put } from './put-operacion-wrm'
import {descargarInforme} from "./descargar-informe";

export const getEndpoint = (url = ''): string => `operaciones/wrm/${url}`

export const HttpWRM = {
    get: get,
    post: post,
    put: put,
    getInstrumentos: getInstrumentos,
    postInstrumento: postInstrumento,
    deleteInstrumento: deleteInstrumento,
    descargarInforme: descargarInforme,
} as const
